import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import { CotisationProvider, CotisationBanner } from "./components/CotisationBanner";
import LoginPage from "./pages/LoginPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import RegisterFoodTruckPage from "./pages/RegisterFoodTruckPage";
import BlockedPage from "./pages/BlockedPage";
import ValidationsPage from "./pages/ValidationsPage";
import DashboardPage from "./pages/DashboardPage";
import FoodTrucksPage from "./pages/FoodTrucksPage";
import FoodTruckDetailPage from "./pages/FoodTruckDetailPage";
import CalendarPage from "./pages/CalendarPage";
import EventDetailPage from "./pages/EventDetailPage";
import AchatsBureauPage from "./pages/AchatsBureauPage";
import CotisationsPage from "./pages/CotisationsPage";
import PaymentsPage from "./pages/PaymentsPage";
import UsersPage from "./pages/UsersPage";
import SettingsPage from "./pages/SettingsPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import MonFoodTruckPage from "./pages/MonFoodTruckPage";
import MesServicesPage from "./pages/MesServicesPage";
import GuidePage from "./pages/GuidePage";
import MesPaiementsPage from "./pages/MesPaiementsPage";
import GalleryPage from "./pages/GalleryPage";
import MessagesPage from "./pages/MessagesPage";
import BilansPage from "./pages/BilansPage";
import CRMPage from "./pages/CRMPage";
import AffairesPage from "./pages/AffairesPage";
import DossierPresentationPage from "./pages/DossierPresentationPage";
import VeillePage from "./pages/VeillePage";
import MesMenusPage from "./pages/MesMenusPage";
import CharteRSEPage from "./pages/CharteRSEPage";
import BilanRSEPage from "./pages/BilanRSEPage";
import RelancesPage from "./pages/RelancesPage";
import TableauAssociationPage from "./pages/TableauAssociationPage";
import BenevolesPage from "./pages/BenevolesPage";
import MailingPage from "./pages/MailingPage";
import HECPlanningPage from "./pages/HECPlanningPage";
import CoutReelHECPage from "./pages/CoutReelHECPage";
import HECGuestPage from "./pages/HECGuestPage";
import PermissionsPage from "./pages/PermissionsPage";
import HelpPage from "./pages/HelpPage";
import SocialMediaPage from "./pages/SocialMediaPage";
import SurveysPage from "./pages/SurveysPage";
import SurveyPublicPage from "./pages/SurveyPublicPage";
import ContractSignaturePage from "./pages/ContractSignaturePage";
import ContractAdminPage from "./pages/ContractAdminPage";
import PlanningGlobalPage from "./pages/PlanningGlobalPage";
import MenuManagementPage from "./pages/MenuManagementPage";
import AnnuairePage from "./pages/AnnuairePage";
import OrganisationEvenementsPage from "./pages/OrganisationEvenementsPage";
import RolesPage from "./pages/RolesPage";
import BlockagesPage from "./pages/BlockagesPage";
import HygienePage from "./pages/HygienePage";
import PlanningUnifiePage from "./pages/PlanningUnifiePage";
import PlanningPage from "./pages/PlanningPage";
import PlacementDirectPage from "./pages/PlacementDirectPage";
import SuiviPlanningsPage from "./pages/SuiviPlanningsPage";
import StripeReportPage from "./pages/StripeReportPage";
import BadgeGeneratorPage from "./pages/BadgeGeneratorPage";
import MonInfoHECPage from "./pages/MonInfoHECPage";
import GestionDroitsHECPage from "./pages/GestionDroitsHECPage";
import SynthesePlanningsPage from "./pages/SynthesePlanningsPage";
import AnnuaireClientsPage from "./pages/AnnuaireClientsPage";
import ClientPortalPage from "./pages/ClientPortalPage";
import CommissionsPage from "./pages/CommissionsPage";
import GestionCommissionsPage from "./pages/GestionCommissionsPage";
import DashboardCommercialPage from "./pages/DashboardCommercialPage";
import HECDocumentsPage from "./pages/HECDocumentsPage";
import HECClientViewPage from "./pages/HECClientViewPage";
import HECPublicMapPage from "./pages/HECPublicMapPage";
import ClientAccountsPage from "./pages/ClientAccountsPage";
import ProspectionPage from "./pages/ProspectionPage";
import FacturationExternePage from "./pages/FacturationExternePage";
import JustificatifsAchatPage from "./pages/JustificatifsAchatPage";
import ProposerEvenementPage from "./pages/ProposerEvenementPage";
import MesPropositionsPage from "./pages/MesPropositionsPage";
import EventResponsePage from "./pages/EventResponsePage";
import PlacementConfirmationPage from "./pages/PlacementConfirmationPage";
import BilanPublicPage from "./pages/BilanPublicPage";
import BilanRapidePage from "./pages/BilanRapidePage";
import DocumentsConformitePage from "./pages/DocumentsConformitePage";
import KpisPerformancePage from "./pages/KpisPerformancePage";
import AvantagesPage from "./pages/AvantagesPage";
import VivierPage from "./pages/VivierPage";
import MonEspaceExtraPage from "./pages/MonEspaceExtraPage";
import "./App.css";
import { useState, useEffect } from "react";
import axios from "axios";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import MobileBottomNav from "./components/MobileBottomNav";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

const ProtectedRoute = ({ children, allowedRoles, skipContractCheck = false, skipAccessCheck = false }) => {
  const { user, loading, token } = useAuth();
  const [accessStatus, setAccessStatus] = useState(null);
  const [checkingAccess, setCheckingAccess] = useState(true);
  const [contractSigned, setContractSigned] = useState(true); // Default true to avoid flashing
  const location = useLocation();
  
  useEffect(() => {
    const checkAccess = async () => {
      if (!token || !user) {
        setCheckingAccess(false);
        return;
      }
      
      try {
        const [accessResponse, contractResponse] = await Promise.all([
          axios.get(`${API_URL}/auth/access-status`, {
            headers: { Authorization: `Bearer ${token}` }
          }),
          // Check contract status for non-admin users
          (user.role !== "admin" && user.role !== "staff_extra")
            ? axios.get(`${API_URL}/contract/status`, {
                headers: { Authorization: `Bearer ${token}` }
              })
            : Promise.resolve({ data: { has_signed: true } })
        ]);
        
        setAccessStatus(accessResponse.data);
        setContractSigned(contractResponse.data.has_signed);
      } catch (error) {
        console.error("Error checking access:", error);
        // If contract check fails, assume signed to not block
        setContractSigned(true);
      } finally {
        setCheckingAccess(false);
      }
    };
    
    if (!loading && user) {
      checkAccess();
    } else if (!loading) {
      setCheckingAccess(false);
    }
  }, [token, user, loading]);
  
  if (loading || checkingAccess) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F7F5]">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }
  
  if (!user) {
    // Preserve the intended destination URL including query params
    const redirectTo = location.pathname + location.search;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirectTo)}`} replace />;
  }
  
  // Check if access is blocked (skip for admin/commercial/client and if skipAccessCheck is true)
  if (!skipAccessCheck && accessStatus?.is_blocked && user.role !== "admin" && user.role !== "commercial" && user.role !== "client") {
    return <Navigate to="/blocked" replace />;
  }
  
  // Check if contract is signed (skip for admin/bureau/commercial/client and contract page itself)
  if (!skipContractCheck && !contractSigned && user.role !== "staff_extra" && user.role !== "admin" && user.role !== "bureau" && user.role !== "commercial" && user.role !== "client") {
    return <Navigate to="/contrat" replace />;
  }
  
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    if (user.role === "staff_extra") {
      return <Navigate to="/mon-espace-extra" replace />;
    }
    // Clients should be redirected to HEC Planning (their only accessible page)
    if (user.role === "client") {
      return <Navigate to="/hec-planning" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

// Smart redirect component based on user role
const RoleBasedRedirect = () => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F7F5]">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  // Clients go directly to HEC Planning
  if (user.role === "client") {
    return <Navigate to="/hec-planning" replace />;
  }
  
  // Extras du vivier : leur seul espace
  if (user.role === "staff_extra") {
    return <Navigate to="/mon-espace-extra" replace />;
  }

  // Commercial goes to their dashboard
  if (user.role === "commercial") {
    return <Navigate to="/dashboard-commercial" replace />;
  }
  
  // Everyone else goes to main dashboard
  return <Navigate to="/dashboard" replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/register" element={<RegisterFoodTruckPage />} />
          <Route path="/blocked" element={<BlockedPage />} />
          
          {/* Public HEC Guest Page - No auth required */}
          <Route path="/hec/guest" element={<HECGuestPage />} />
          
          {/* Public Survey Response Page - No auth required */}
          <Route path="/sondage/:token" element={<SurveyPublicPage />} />
          
          {/* Public Event Response Page - One-click interest confirmation from email */}
          <Route path="/event-response/:token" element={<EventResponsePage />} />
          <Route path="/placement-confirmation/:token" element={<PlacementConfirmationPage />} />
          
          {/* Public Bilan Page - Manual bilan submission from email */}
          <Route path="/bilan-public/:token" element={<BilanPublicPage />} />
          <Route path="/b/:token" element={<BilanRapidePage />} />
          
          {/* Public Client Portal - No auth required, secured by token */}
          <Route path="/client-portal" element={<ClientPortalPage />} />
          
          {/* Public HEC Documents - No auth required, secured by token */}
          <Route path="/hec-documents/:planningId" element={<HECDocumentsPage />} />
          
          {/* Public HEC Client View - No auth required, secured by token */}
          <Route path="/hec-client/:planningId" element={<HECClientViewPage />} />
          
          {/* Public HEC Map - No auth, no token required */}
          <Route path="/carte-hec" element={<HECPublicMapPage />} />
          
          <Route path="/" element={<RoleBasedRedirect />} />
          
          {/* Redirect /adherents to /food-trucks */}
          <Route path="/adherents" element={<Navigate to="/food-trucks" replace />} />
          
          <Route path="/vivier" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "membre", "tresorier", "president"]}>
              <Layout><VivierPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/mon-espace-extra" element={
            <ProtectedRoute allowedRoles={["staff_extra"]} skipContractCheck skipAccessCheck>
              <Layout><MonEspaceExtraPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "membre", "benevole"]}>
              <Layout><DashboardPage /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/food-trucks" element={
            <ProtectedRoute>
              <Layout><FoodTrucksPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/ma-fiche-camion" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "commercial", "membre", "benevole", "tresorier", "president"]}>
              <Navigate to="/mon-food-truck?tab=dossier" replace />
            </ProtectedRoute>
          } />

          <Route path="/dossier-presentation" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "commercial"]}>
              <Layout><DossierPresentationPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/appels-offres" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><AffairesPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/veille" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><VeillePage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/mes-menus" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "commercial", "membre", "benevole", "tresorier", "president"]}>
              <Layout><MesMenusPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/tableau-association" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><TableauAssociationPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/relances-adherents" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><RelancesPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/bilan-rse" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "membre", "tresorier", "president"]}>
              <Layout><BilanRSEPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/charte-rse" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "commercial", "membre", "benevole", "tresorier", "president"]}>
              <Layout><CharteRSEPage /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/food-trucks/:id" element={
            <ProtectedRoute>
              <Layout><FoodTruckDetailPage /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/calendar" element={
            <ProtectedRoute>
              <Layout><CalendarPage /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/events/:id" element={
            <ProtectedRoute>
              <Layout><EventDetailPage /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/achats-bureau" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><AchatsBureauPage /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/cotisations" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><CotisationsPage /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/payments" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><PaymentsPage /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/users" element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Layout><UsersPage /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/settings" element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Layout><SettingsPage /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/admin/validations" element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Layout><ValidationsPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* CRM - Bureau, Admin and Commercial */}
          <Route path="/crm" element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Layout><CRMPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Mailing - Bureau, Admin and Commercial */}
          <Route path="/mailing" element={
            <ProtectedRoute allowedRoles={["bureau", "admin", "commercial"]}>
              <Layout><MailingPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* HEC Planning - Bureau, Admin, Benevole and Client (read-only for client) */}
          <Route path="/hec-planning" element={
            <ProtectedRoute allowedRoles={["bureau", "admin", "benevole", "client"]}>
              <Layout><HECPlanningPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Coût Réel HEC - Admin only */}
          <Route path="/cout-reel-hec" element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Layout><CoutReelHECPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Planning Global - Bureau, Admin and Commercial */}
          <Route path="/planning-global" element={
            <ProtectedRoute allowedRoles={["bureau", "admin", "commercial"]}>
              <Layout><PlanningGlobalPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Permissions Management - Admin only */}
          <Route path="/permissions" element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Layout><PermissionsPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Member routes (Food Trucks) - Also accessible to bureau + admin (un admin peut aussi posseder un food truck et deposer ses documents) */}
          <Route path="/mon-food-truck" element={
            <ProtectedRoute allowedRoles={["membre", "bureau", "admin"]}>
              <Layout><MonFoodTruckPage /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/mes-services" element={
            <ProtectedRoute allowedRoles={["membre", "bureau"]}>
              <Layout><MesServicesPage /></Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/mes-paiements" element={
            <ProtectedRoute allowedRoles={["membre", "bureau"]}>
              <Layout><MesPaiementsPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Proposer un événement - Members only */}
          <Route path="/proposer-evenement" element={
            <ProtectedRoute allowedRoles={["membre"]}>
              <Layout><ProposerEvenementPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Mes Propositions - accessible to all food trucks */}
          <Route path="/mes-propositions" element={
            <ProtectedRoute>
              <Layout><MesPropositionsPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Gallery - accessible to all authenticated users */}
          <Route path="/gallery" element={
            <ProtectedRoute>
              <Layout><GalleryPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Messages - accessible to all authenticated users */}
          <Route path="/messages" element={
            <ProtectedRoute>
              <Layout><MessagesPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Bilans - Admin and Bureau only */}
          <Route path="/bilans" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><BilansPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Bénévoles - Admin and Bureau only */}
          <Route path="/benevoles" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><BenevolesPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Payment routes */}
          <Route path="/payment/success" element={
            <ProtectedRoute>
              <PaymentSuccessPage />
            </ProtectedRoute>
          } />
          
          <Route path="/payment/cancel" element={
            <ProtectedRoute>
              <PaymentCancelPage />
            </ProtectedRoute>
          } />
          
          {/* Help page - accessible to all authenticated users */}
          <Route path="/aide" element={
            <ProtectedRoute>
              <Layout><HelpPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/guide" element={
            <ProtectedRoute allowedRoles={["membre", "bureau", "admin"]}>
              <Layout><GuidePage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/social-media" element={
            <ProtectedRoute>
              <Layout><SocialMediaPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Sondages - Admin, Bureau and Commercial */}
          <Route path="/sondages" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "commercial"]}>
              <Layout><SurveysPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Contract signature - accessible to all authenticated users (even blocked) */}
          <Route path="/contrat" element={
            <ProtectedRoute skipContractCheck={true} skipAccessCheck={true}>
              <ContractSignaturePage />
            </ProtectedRoute>
          } />
          
          {/* Contract Admin - Admin only */}
          <Route path="/gestion-contrats" element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Layout><ContractAdminPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Menu Management */}
          <Route path="/mon-menu" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "membre"]}>
              <Layout><MenuManagementPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Annuaire Food Trucks */}
          <Route path="/annuaire" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "benevole"]}>
              <Layout><AnnuairePage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Organisation Événements */}
          <Route path="/organisation-evenements" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "commercial"]}>
              <Layout><OrganisationEvenementsPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Rôles & Responsabilités */}
          <Route path="/roles" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><RolesPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Gestion des Blocages */}
          <Route path="/blockages" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><BlockagesPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Module Hygiène HACCP */}
          <Route path="/hygiene" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "membre"]}>
              <Layout><HygienePage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Planning unifie (Gestion + Synthese + Vue globale) */}
          {/* Placement Direct */}
          {/* Suivi des plannings */}
          <Route path="/paiements-stripe" element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Layout><StripeReportPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/documents-conformite" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><DocumentsConformitePage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/kpis-performance" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><KpisPerformancePage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/avantages" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "commercial", "membre"]}>
              <Layout><AvantagesPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/suivi-plannings" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "commercial"]}>
              <Layout><SuiviPlanningsPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/placement-direct" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><PlacementDirectPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/planning" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "commercial", "benevole", "membre"]}>
              <Layout><PlanningPage /></Layout>
            </ProtectedRoute>
          } />

          {/* Planning Unifié - Admin, Bureau and Commercial */}
          <Route path="/planning-unifie" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "commercial", "benevole", "membre"]}>
              <Layout><PlanningUnifiePage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Badge Generator - Admin and Bureau only */}
          <Route path="/badge-generator" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><BadgeGeneratorPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Mon Info HEC - Members can edit their own HEC info */}
          <Route path="/mon-info-hec" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "membre"]}>
              <Layout><MonInfoHECPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Gestion Droits HEC - Admin only */}
          <Route path="/gestion-droits-hec" element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Layout><GestionDroitsHECPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Synthèse Plannings - Admin, Bureau and Commercial */}
          <Route path="/synthese-plannings" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "commercial"]}>
              <Layout><SynthesePlanningsPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Annuaire Clients - Admin, Bureau and Commercial */}
          <Route path="/annuaire-clients" element={
            <ProtectedRoute allowedRoles={["admin", "bureau", "commercial"]}>
              <Layout><AnnuaireClientsPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/commissions" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><CommissionsPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/gestion-commissions" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><GestionCommissionsPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/client-accounts" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><ClientAccountsPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/dashboard-commercial" element={
            <ProtectedRoute allowedRoles={["commercial"]}>
              <Layout><DashboardCommercialPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Prospection - Bureau and Admin only */}
          <Route path="/prospection" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><ProspectionPage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Facturation Externe - Admin only */}
          <Route path="/facturation-externe" element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Layout><FacturationExternePage /></Layout>
            </ProtectedRoute>
          } />
          
          {/* Justificatifs d'Achat - Admin/Bureau only */}
          <Route path="/justificatifs-achat" element={
            <ProtectedRoute allowedRoles={["admin", "bureau"]}>
              <Layout><JustificatifsAchatPage /></Layout>
            </ProtectedRoute>
          } />
        </Routes>
        <MobileBottomNav />
        <PWAInstallPrompt />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
